import React, { useState, useEffect } from "react";
import { ServerTypeHelper } from "../../../../_config/helpers";
import { useTranslation } from "react-i18next";
import "./LayerScope.css";
import { AutoComplete } from "primereact/autocomplete";
import { FloatLabel } from "primereact/floatlabel";

const LayerScope = (props) => {
  const { t } = useTranslation();

  const [layers, setLayers] = useState([]);

  const [layerSearchTerms, setLayerSearchTerms] = useState([]);

  const [LayerScope, setLayerScope] = useState([]);

  const [filteredLayers, setFilteredLayers] = useState([]);
  const [selectedLayer, setSelectedLayer] = useState(null);

  const activeFolderContentVisibility = (content) => {
    content.style.visibility = "visible";

    content.style.display = "inherit";

    content.style.opacity = "1";
  };

  const handleLayerSearchTermsChange = () => {
    try {
      layerSearchTerms.forEach((layerId) => {
        let e = document.querySelector(`#layer${layerId}`);
        let label = document.querySelector(`#layerTitle${layerId}`);
        label.style.animation = "blink 1s infinite";
        let layerFolder =
          e.parentNode.parentNode.parentNode.parentNode.parentNode;
        let layerFolderImage = document.querySelector(
          `#${layerFolder.id}image`
        );
        layerFolderImage.style.animation = "blink 1s infinite";
        let content = e.parentNode.parentNode.parentNode.parentNode;
        let key = 0;

        activeFolderContentVisibility(content);

        while (
          layerFolder.parentNode.parentNode.className === `LayerFolder` &&
          key < 5
        ) {
          content = layerFolder.parentNode;
          layerFolder = layerFolder.parentNode.parentNode;
          layerFolderImage = document.querySelector(`#${layerFolder.id}image`);
          layerFolderImage.style.animation = "blink 1s infinite";
          activeFolderContentVisibility(content);
          key++;
        }
      });
    } catch (e) {
      console.log(e);
    }
  };

  const handleLayerTargetChange = (e) => {
    const layerTargets = [];

    layers.forEach((layer, key) => {
      if (t(layer.get(`title`)) === e.target.value) layerTargets.push(key);
    });

    setLayerSearchTerms(layerTargets);

    return true;
  };

  const buildLayerTarget = (layer, id) => {
    return (
      <option
        key={id}
        className={"LayerTarget"}
        value={t(layer.get(`title`))}
      ></option>
    );
  };

  const buildLayerScope = () => {
    return setLayerScope(
      layers.map(
        (layer, key) =>
          layer.get(`serverType`) === ServerTypeHelper.GEOSERVER &&
          buildLayerTarget(layer, key)
      )
    );
  };

  useEffect(buildLayerScope, [layers]);

  useEffect(buildLayerScope, [props.currentLanguage]);

  useEffect(handleLayerSearchTermsChange, [layerSearchTerms]);

  useEffect(() => {
    if (!props.map) return;
    setLayers([...props.map.getLayers().getArray()]);
  }, [props.map]);

  const handleSelect = (e) => {
    const value = e.value;
    const layerTargets = [];
    layers.forEach((layer, key) => {
      if (t(layer.get("title")) === value) layerTargets.push(key);
    });
   
  };

  const searchLayer = (event) => {
    const query = event.query.toLowerCase();
    const filtered = layers
      .filter(
        (layer) =>
          layer.get("serverType") === ServerTypeHelper.GEOSERVER &&
          t(layer.get("title")).toLowerCase().includes(query)
      )
      .map((layer) => t(layer.get("title")));
    setFilteredLayers(filtered);
  };

  return (
    <div id={"LayerScope"} className={"LayerScope"}>
      <div className="LayerTargerFilterSet">
        <FloatLabel>
          <AutoComplete
            id="layerScopeInput"
            value={selectedLayer}
            suggestions={filteredLayers}
            completeMethod={searchLayer}
            onChange={(e) => {
              setSelectedLayer(e.value);
              handleLayerTargetChange({ target: { value: e.value } });
            }}
            onSelect={handleSelect}
            dropdown
            className="LayerTargerFilter"
          />
          <label htmlFor="layerScopeInput" className="labelSearch">
            {t("layerScope.placeholder")}
          </label>
        </FloatLabel>
      </div>
    </div>
  );
};

export default LayerScope;
